import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, unref as _unref, createCommentVNode as _createCommentVNode, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "remind" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "label_title" }, "余额不足提醒：", -1)
const _hoisted_3 = { class: "content" }

import { reactive, ref, onMounted } from 'vue';
import { Modal, message } from 'ant-design-vue';
import { MinusCircleOutlined } from '@ant-design/icons-vue';
import { mobileReg } from '@/utils/illuminate';
import { createApiUrl } from '@/utils/utils';
import { request } from '@/utils/request';
import { useState } from '@/store';

interface Domain {
  name: string;
  label: string;
  userCode: number | undefined;
  phone: string;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'BalanceReminder',
  props: {
  defaultDataList: { type: Array, required: true },
},
  setup(__props) {

const formItemLayoutWithOutLabel = {
  labelCol: {
    span: 6,
  },
  wrapperCol: {
    span: 18,
  },
};
const formItemLayout = {
  wrapperCol: {
    offset: 6,
    span: 18,
  },
};
const props = __props;
const state = useState();
const remindMsg = ref('');
const inputValue = ref('');
const balanceFlag = ref(0);
const options = ref<Domain[]>([]);
const formRef = ref();
const dynamicValidateForm = reactive<{ threshold: number | undefined, receiverList: Domain[] }>({
  threshold: undefined,
  receiverList: [
    { label: '', userCode: undefined, phone: '', name: '' },
  ],
});
// 初始调用
onMounted(() => {
  request.get(createApiUrl('/newlinkSass/alertConfig/queryByEnterpriseId'), { params: { enterpriseId: state.enterprise.value.enterpriseId } }).then((res: any) => {
    const cur = res.data.find((item: any) => item.type === 1);
    let { alertReceiverList = [] } = cur || {};
    alertReceiverList = alertReceiverList && alertReceiverList.map((cur: any) => {
      if (cur.userCode) return ({ ...cur, label: `${cur.name}${cur.roleNames ? `（${cur.roleNames.split(',')?.[0]}）` : ''}${cur.phone.substr(0, 3)}****${cur.phone.substr(7)}` });
      return { ...cur, label: cur.name };
    });
    dynamicValidateForm.receiverList = alertReceiverList || [{ label: '', userCode: undefined, phone: '', name: '' }];
    options.value = JSON.parse(JSON.stringify(alertReceiverList || []));
    dynamicValidateForm.threshold = cur.threshold;
    balanceFlag.value = cur.status;
  });
});
const checkNumber = async (rule: any, value: number) => {
  if (value > 9999999 || value < 1) return Promise.reject('提醒金额填写错误，请输入1-9999999之间的整数');
  return Promise.resolve();
};
// 手机号输入员工搜索
const handleSearch = (value: string) => {
  request.get(createApiUrl('/newlinkSass/enterprise/find-enterprise-user-list'), { params: { enterpriseId: state.enterprise.value.enterpriseId, nameOrPhone: value } }).then((res: any) => {
    const { data, code } = res;
    if (code !== 200) return message.error(res.message);
    options.value = data.list.map((cur:any) => ({ userCode: Number(cur.id), label: `${cur.userName}${cur.roleNames ? `（${cur.roleNames.split(',')?.[0]}）` : ''}${cur.phone.substr(0, 3)}****${cur.phone.substr(7)}`, phone: cur.phone, name: cur.userName }));
    inputValue.value = value;
  });
};
// 手机号输入失去焦点
const handleBlur = (e: Event, index: number) => {
  if (!options.value.length) {
    dynamicValidateForm.receiverList.splice(index, 1, { userCode: undefined, label: inputValue.value, phone: inputValue.value, name: inputValue.value });
  }
};
// 选项改变时
const handleChange = (value: string, index: number) => {
  const cur = options.value.find(item => item.phone === value) || { userCode: undefined, label: '', phone: '', name: '' };
  dynamicValidateForm.receiverList.splice(index, 1, cur);
};
// 删除手机号
const removeDomain = (item: Domain) => {
  const index = dynamicValidateForm.receiverList.indexOf(item);
  if (index !== -1) {
    dynamicValidateForm.receiverList.splice(index, 1);
  }
};
// 添加手机号
const addDomain = () => {
  if (dynamicValidateForm.receiverList.length < 5) {
    dynamicValidateForm.receiverList.push({
      userCode: undefined,
      label: '',
      phone: '',
      name: '',
    });
  } else {
    message.warning('最多只能添加5个手机号码');
  }
};
// 开/关 提醒
const handleBalanceFlag = async (val: any) => {
  const ajaxUrl = val.target.value === 1 ? '/newlinkSass/alertConfig/open' : '/newlinkSass/alertConfig/close';
  const params = { enterpriseId: state.enterprise.value.enterpriseId, type: 1 };
  await request.post(createApiUrl(ajaxUrl), params).then((res: any) => {
    if (res.code !== 200) return message.error(res.message);
    balanceFlag.value = val.target.value;
    const msg = ' 余额不足提醒 功能操作成功';
    remindMsg.value = val.target.value === 1 ? `开启${msg}` : `关闭${msg}`;
    Modal.success({
      title: '操作成功',
      content: remindMsg.value,
    });
  }).catch((err: any) => {
    message.error(err.message);
  });
};
// 提交表单
const onSubmit = async () => {
  let isSubmit = 0;

  formRef.value.validate().then(() => {
    dynamicValidateForm.receiverList.map(item => {
      if (!mobileReg.test(item.phone)) {
        isSubmit += 1;
      }
    });
    if (isSubmit === 0) {
      const params = { 
        enterpriseId: state.enterprise.value.enterpriseId, 
        type: 1, 
        threshold: dynamicValidateForm.threshold,
        receiverList: dynamicValidateForm.receiverList,
      };
      request.post(createApiUrl('/newlinkSass/alertConfig/saveConfig'), params)
        .then((res: any) => {
          const { data, code } = res;
          if (code !== 200) return message.error('保存失败');
          message.success('余额提醒设置更改成功');
        })
        .catch((err: any) => {
          message.error(err.message || '保存失败');
        });
    } else {
      message.warning('手机号码格式不正确');
    }
  }).catch((error: any) => {
    console.log('error', error);
  });
};

return (_ctx: any,_cache: any) => {
  const _component_a_radio = _resolveComponent("a-radio")!
  const _component_a_radio_group = _resolveComponent("a-radio-group")!
  const _component_a_input_number = _resolveComponent("a-input-number")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_select_option = _resolveComponent("a-select-option")!
  const _component_a_select = _resolveComponent("a-select")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_a_radio_group, {
        value: balanceFlag.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((balanceFlag).value = $event)),
        onChange: handleBalanceFlag
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_radio, { value: 1 }, {
            default: _withCtx(() => [
              _createTextVNode("开启")
            ]),
            _: 1
          }),
          _createVNode(_component_a_radio, { value: 0 }, {
            default: _withCtx(() => [
              _createTextVNode("关闭")
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["value"]),
      _createVNode(_component_a_form, _mergeProps({
        ref_key: "formRef",
        ref: formRef,
        model: dynamicValidateForm
      }, formItemLayoutWithOutLabel), {
        default: _withCtx(() => [
          _createVNode(_component_a_form_item, {
            name: "threshold",
            label: "提醒金额",
            extra: "当余额少于此金额时将发送短信提醒",
            rules: [{required: true, message: '请填写提示金额'}, {validator: checkNumber, trigger: 'change' }]
          }, {
            default: _withCtx(() => [
              _createVNode(_component_a_input_number, {
                value: dynamicValidateForm.threshold,
                "onUpdate:value": _cache[1] || (_cache[1] = ($event: any) => ((dynamicValidateForm.threshold) = $event)),
                precision: 0,
                style: {"width":"100%"}
              }, null, 8, ["value"])
            ]),
            _: 1
          }, 8, ["rules"]),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dynamicValidateForm.receiverList, (domain, index) => {
            return (_openBlock(), _createBlock(_component_a_form_item, _mergeProps({ key: index }, index === 0 ? {} : formItemLayout, {
              label: index === 0 ? '接收手机' : '',
              name: ['receiverList', index, 'phone'],
              rules: [{
            required: true,
            message: '请填写手机号'
          }, {
            pattern: /^\d{11}$/, message: '手机号码格式不正确', trigger: 'blur'
          }]
            }), {
              default: _withCtx(() => [
                _createVNode(_component_a_select, {
                  value: domain.phone,
                  "onUpdate:value": ($event: any) => ((domain.phone) = $event),
                  placeholder: "请输入接收手机",
                  "show-search": "",
                  "default-active-first-option": false,
                  "show-arrow": false,
                  "filter-option": false,
                  "not-found-content": null,
                  onSearch: handleSearch,
                  onChange: (value) => handleChange(value, index),
                  onBlur: (e) => handleBlur(e, index)
                }, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(options.value, (item) => {
                      return (_openBlock(), _createBlock(_component_a_select_option, {
                        key: index + item.label,
                        value: item.phone
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.label || ''), 1)
                        ]),
                        _: 2
                      }, 1032, ["value"]))
                    }), 128))
                  ]),
                  _: 2
                }, 1032, ["value", "onUpdate:value", "onChange", "onBlur"]),
                (dynamicValidateForm.receiverList.length > 1)
                  ? (_openBlock(), _createBlock(_unref(MinusCircleOutlined), {
                      key: 0,
                      class: "dynamic-delete-button",
                      onClick: ($event: any) => (removeDomain(domain))
                    }, null, 8, ["onClick"]))
                  : _createCommentVNode("", true)
              ]),
              _: 2
            }, 1040, ["label", "name"]))
          }), 128)),
          _createVNode(_component_a_form_item, _mergeProps(formItemLayout, { colon: false }), {
            default: _withCtx(() => [
              _createVNode(_component_a_button, { onClick: addDomain }, {
                default: _withCtx(() => [
                  _createTextVNode("增加")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 16),
          _createVNode(_component_a_form_item, _mergeProps(formItemLayout, { colon: false }), {
            default: _withCtx(() => [
              _createVNode(_component_a_button, {
                type: "primary",
                onClick: onSubmit
              }, {
                default: _withCtx(() => [
                  _createTextVNode("保存更改")
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 16)
        ]),
        _: 1
      }, 16, ["model"])
    ])
  ]))
}
}

})